import { ProgressBar } from "primereact/progressbar";
import PillarElement from "./ZeroTrustPillarElement";
import { Button } from "primereact/button";
import { ZT } from "./ZeroTrustData";

export default function ZeroTrustContent(props:any){
    return(
        <div className='container-zero-trust-content'>
            <div className='flex d-flex' style={{textAlign: 'start'}}>
                <div className='col-2'></div>
                {props.actions.phases.map((phase:any) => {
                    let phaseName = 'Phase ' + phase;
                    if(phase === 0) phaseName = 'Discovery';
                    const value = props.actions.metrics?.phaseOrder?.[phase] * 100 || 0;
                    return(
                        <div className='col-2' key={`phaser-${phaseName}`}>
                            <Button className='zt-btn' size='small' label={phaseName} outlined style={{width: '100%'}} 
                                    onClick={() => props.dispatch({type : 'update', field: 'showPhase', payload: String(phase)})}/>
                            <ProgressBar className='zt-prgb' value={value} showValue={false} color='green'/>
                        </div>
                    )
                })}
            </div>
            <div className='container-zero-trust-content-body'>
                {props.actions.pillars.map((p:any) => {
                    return(
                        <PillarElement pdata={ZT.pillars[p]} actions={props.actions} dispatch={props.dispatch}/>
                    )
                })}
            </div>
        </div>
    )
}